import { useTranslations } from '@vocab/react';
import {
  Actions,
  Box,
  ButtonLink,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';
import React from 'react';

import { useConfig } from '../../../../hooks/useConfig';
import { USER_MANAGEMENT } from '../links';

import translations from './.vocab';
import AddUsersIcon from './AddUsersIcon';

export const AddTeamMemberView = () => {
  const { t } = useTranslations(translations);
  const { urlResolver } = useConfig();

  return (
    <Box display="flex" justifyContent="center" marginY="xlarge">
      <Box textAlign="center" maxWidth="small">
        <Stack space="medium">
          <Box>
            <AddUsersIcon />
          </Box>
          <Heading level="4">{t('No team members added yet')}</Heading>
          <Text tone="secondary">
            {t('To add team members to this job...')}
          </Text>
          <Box display="flex" justifyContent="center">
            <Actions>
              <ButtonLink
                href={urlResolver({ path: USER_MANAGEMENT })}
                target="_blank"
                rel="noopener"
              >
                {t('Add team members to account')}
              </ButtonLink>
            </Actions>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};
